import { render, staticRenderFns } from "./TCUsers.vue?vue&type=template&id=4432be33&"
import script from "./TCUsers.vue?vue&type=script&lang=js&"
export * from "./TCUsers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports